import GoldTick from '/public/images/icons/selectedGoldTick.svg?react'

export default function SubscriptionProductCard({ product, isActive, onClick }) {
  return (
    <div className={`flex flex-row items-center gap-[12px] p-[13px] bg-white rounded-lg border cursor-pointer relative ${isActive ? 'border-sportsYellow' : 'border-[#E3E3E3]'}`} onClick={onClick}>
      <div className="border border-[#E3E3E3] rounded-[4px] p-[5px] bg-[#F8F8F8]">
        <img src={product?.ProductImage} alt={product?.Name} className="w-[50px] h-[50px] contain" />
      </div>
      <div>
        <p className="font-semibold text-sportsBlack">{product?.Name}</p>
        <p className="text-sportsDarkGrey text-[12px]">£{product?.Price} extra per year</p>
      </div>
      {isActive && (
        <GoldTick className="absolute top-1/2 right-0 transform -translate-y-1/2" />
      )}
    </div>
  );
}